import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
	"p",
	"br",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"ul",
	"ol",
	"li",
	"pre",
	"code",
	"hr",
	"strong",
	"em",
	"s",
	"a",
	"span",
];

const ALLOWED_ATTR = ["href", "target", "rel", "style"];

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
	if (node.tagName === "A" && node.getAttribute("href")) {
		node.setAttribute("target", "_blank");
		node.setAttribute("rel", "noopener noreferrer");
	}
});

export const sanitizeHtml = (html: string): string =>
	DOMPurify.sanitize(html, {
		ALLOWED_TAGS,
		ALLOWED_ATTR,
		ALLOWED_URI_REGEXP: /^(?:https?|mailto|tel):/i,
	});
